<template>

<div class="w-full surface-100">
    <div class="center xl:pt-0 xl:pb-8 lg:pt-0 xl:pb-7 md:pt-0 md:pb-6">
        <div class="flex flex-column pt-6 xl:pt-8 justify-content-center align-items-center text-center">

            <div class="flex text-900 font-semibold
                text-3xl xl:text-6xl lg:text-5xl md:text-4xl sm:text-3xl
                mb-2 xl:mb-5 lg:mb-4 mb:mb-3">
                {{ content[lang_].title }}
            </div>

            <div class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row 
                px-3 py-3" >

                <div class="w-full flex flex-grow-1
                    flex-row xl:flex-column lg:flex-column md:flex-column
                    gap-2 xl:gap-5 lg:gap-3
                    xl:pr-3 lg:pr-2 md:pr-2">

                    <div class="w-full flex flex-column xl:flex-row lg:flex-row">
                        <div class="w-full flex flex-column surface-0 flex-1 
                            relative
                            p-3 xl:p-6 lg:p-5 md:p-4
                            border-round-2xl xl:border-round-3xl 
                            border-ios-xl xl:border-ios-2xl lg:border-ios-2xl 
                            text-left
                            mb-3 xl:m-0 lg:m-0 md:m-0">

                            <div class="flex flex-row">
                                <div class="flex flex-grow-1 text-700 font-semibold mb-5 text-xl xl:text-4xl lg:text-3xl md:text-2xl sm:text-2xl">
                                    <span class="w-full max-w-20rem">
                                        {{ content[lang_].text1 }}
                                    </span>
                                </div>
                                <div class="flex-grow-0">
                                    <Button :label="content[lang_].button" class="flex px-1 text-sm xl:text-base lg:text-base md:text-sm" 
                                        text severity="info"
                                        icon="pi pi-chevron-right text-sm xl:text-base lg:text-base md:text-sm" iconPos="right"
                                        @click="open_popup()" />
                                </div>
                            </div>
                                
                            <div class="w-full flex flex-row">
                                <div class="m-0 xl:m-auto lg:m-auto md:m-auto">
                                    <div class="flex flex-grow-1 
                                        flex-column xl:flex-row lg:flex-row md:flex-row">

                                        <div class="flex align-items-center
                                            w-full xl:max-w-15rem lg:max-w-15rem md:max-w-15rem
                                            mb-3 xl:mx-3 lg:mx-2 md:mx-2
                                            xl:text-center lg:text-center md:text-center 
                                            flex-row xl:flex-column lg:flex-column md:flex-column">
                                            <div class="flex border-circle bg-green-200 relative flex-shrink-0
                                                h-4rem w-4rem xl:h-7rem xl:w-7rem lg:h-6rem lg:w-6rem md:h-5rem md:w-5rem"> 
                                                <img src="/images/svg/icons/howitwork1.svg" class="block absolute p-1 xl:p-3" style="width:100%;height:100%;">
                                            </div>
                                            <span class="text-600
                                                xl:mt-4 lg:mt-4 md:mt-4
                                                pl-4 xl:px-2 lg:px-2 md:px-2
                                                text-base xl:text-md lg:text-md">
                                                {{ steps.first[lang_] }}
                                            </span>
                                        </div>

                                        <div class="flex align-items-center
                                            w-full xl:max-w-15rem lg:max-w-15rem md:max-w-15rem
                                            mb-3 xl:mx-4 lg:mx-4 md:mx-4
                                            xl:text-center lg:text-center md:text-center 
                                            flex-row xl:flex-column lg:flex-column md:flex-column">
                                            <div class="flex border-circle bg-green-200 relative flex-shrink-0
                                                h-4rem w-4rem xl:h-7rem xl:w-7rem lg:h-6rem lg:w-6rem md:h-5rem md:w-5rem">
                                                <img src="/images/svg/icons/howitwork2.svg" class="block absolute p-1 xl:p-3" style="width:100%;height:100%;">
                                            </div>
                                            <span class=" text-600
                                                xl:mt-4 lg:mt-4 md:mt-4
                                                pl-4 xl:px-2 lg:px-2 md:px-2
                                                text-base xl:text-md lg:text-md">
                                                {{ steps.second[lang_] }}  
                                            </span>
                                        </div>


                                        <div class="flex align-items-center
                                            w-full xl:max-w-15rem lg:max-w-15rem md:max-w-15rem
                                            mb-3 xl:mx-4 lg:mx-4 md:mx-4
                                            xl:text-center lg:text-center md:text-center 
                                            flex-row xl:flex-column lg:flex-column md:flex-column">
                                            <div class="flex border-circle bg-green-200 relative flex-shrink-0
                                                h-4rem w-4rem xl:h-7rem xl:w-7rem lg:h-6rem lg:w-6rem md:h-5rem md:w-5rem">
                                                <img src="/images/svg/icons/howitwork3.svg" class="block absolute p-1 xl:p-3" style="width:100%;height:100%;">
                                            </div>
                                            <span class=" text-600
                                                xl:mt-4 lg:mt-4 md:mt-4
                                                pl-4 xl:px-2 lg:px-2 md:px-2
                                                text-base xl:text-md lg:text-md">
                                                {{ steps.third[lang_] }}
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="flex  flex-grow-0
                    flex-row xl:flex-column lg:flex-column md:flex-column
                    gap-2 xl:gap-5 lg:gap-3
                    xl:pl-3 lg:pl-2 md:pl-2">

                    <div class="w-full flex h-full
                        flex-row xl:flex-column lg:flex-column md:flex-column 
                        gap-3 xl:gap-5 lg:gap-34">
                        
                        <div class="w-full flex flex-column surface-0 flex-1 
                            relative
                            p-3 xl:p-4 lg:p-4 md:p-4
                            xl:h-12rem lg:h-10rem md:h-8rem 
                            border-round-xl xl:border-round-3xl lg:border-round-2xl 
                            xl:border-ios-4xl border-ios-xl
                            text-left">
                            <span class="flex flex-grow-1 w-full text-700 font-semibold
                                text-md xl:text-2xl lg:text-xl md:text-lg
                                mb-4">
                                {{ content[lang_].text2 }}
                            </span>
                            <div class="flex w-full">
                                <Button :label="content[lang_].button" class="flex px-1 text-sm xl:text-base lg:text-base md:text-sm" 
                                    text severity="info"
                                    icon="pi pi-chevron-right text-sm xl:text-base lg:text-base md:text-sm" iconPos="right"
                                    @click="showCash()" />
                            </div>
                        </div>

                        <div class="w-full flex flex-column surface-0 flex-1 
                            relative
                            p-3 xl:p-4 lg:p-4 md:p-4
                            xl:h-12rem lg:h-10rem md:h-8rem
                            border-round-xl xl:border-round-3xl lg:border-round-2xl 
                            xl:border-ios-4xl border-ios-xl
                            text-left">
                            <span class="flex flex-grow-1 w-full text-700 font-semibold
                                text-md xl:text-2xl lg:text-xl md:text-lg
                                mb-4">
                                {{ content[lang_].text3 }}
                            </span>
                            <div class="flex w-full">
                                <Button :label="content[lang_].button" class="flex px-1 text-sm xl:text-base lg:text-base md:text-sm" 
                                    text severity="info" 
                                    icon="pi pi-chevron-right text-sm xl:text-base lg:text-base md:text-sm" iconPos="right"
                                    @click="showBills()" />
                            </div>
                        </div>

                    </div>
                    
                </div>
                
            </div>

        </div>
    </div>
</div>

<Dialog v-model:visible="popup" modal :header="content[lang_].text1" 
    class="w-full mx-1 border-round-xl overflow-hidden" style="max-width: 640px;">
    <TransferPage />
</Dialog>

<Dialog v-model:visible="cashPopup" modal :header="content[lang_].text2" 
    class="w-full mx-1 border-round-xl overflow-hidden" style="max-width: 640px;">
    <div class="surface-100 border-round-xl">
        <CashPage />
    </div>
</Dialog>

<Dialog v-model:visible="billPopup" modal :header="content[lang_].text3" 
    class="w-full mx-1 border-round-xl overflow-hidden" style="max-width: 640px;">
    <div class="surface-100 border-round-xl">
        <BillPage />
    </div>
</Dialog>

</template>


<script>
import Helper       from '@/assets/js/Helper'
import TransferPage from '@/components/widgets/TransferPage.vue' 
import BillPage     from '@/components/personal/bill/Be.vue'
import CashPage     from '@/components/widgets/CashPage.vue' 

export default {
    data(){
        return {
			content: {
				ru: {
					title: 'Как это работает',
                    text1: 'Отправляйте переводы онлайн',
                    text2: 'Снимайте наличные в АТМ',
                    text3: 'Принимайте платежи',
					button: 'Подробно',
				},
				en: {
					title: 'How it works',
                    text1: 'Send transfers online',
                    text2: 'Withdraw cash at ATMs',
                    text3: 'Accept payments',
                    button: 'Details',
				},
			},
            steps: {
                first: {
                    ru: 'Вы создаете трансфер на сайте',
                    en: 'You create a transfer on the website',
                },
                second: {
                    ru: 'Оплачиваете трансфер простым переводом по номеру карты',
                    en: 'You pay for the transfer with a simple transfer to the card number',
                },
                third: {
                    ru: 'Получаете перевод на локальную карту или банкомат в местной валюте',
                    en: 'You receive a transfer to a local card or ATM in local currency',
                },
            },
            popup: false,
            billPopup: false,
            cashPopup: false,
        }
    },
    components: {
        TransferPage,
        BillPage,
        CashPage,
    },
	computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        },  
    },
	methods: {
        open_popup() {
            this.popup = true
        },
        showBills() {
            this.billPopup = true
        },
        showCash() {
            this.cashPopup = true
        },
	},
    async beforeCreate(){
        this.helper = new Helper()
    }
}
</script>
